import { render, staticRenderFns } from "./SingleSelection.vue?vue&type=template&id=6d473632"
import script from "./SingleSelection.vue?vue&type=script&lang=js"
export * from "./SingleSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports